import { type FC, memo } from 'react';

import {
  createInstance,
  OptimizelyProvider,
  setLogger,
} from '@optimizely/react-sdk';
import { OptimizelyAnalyticsEvent } from './optimizely-analytics-event';
import type { OptimizelyProps } from './optimizely.types';

setLogger(null); // comment to enable optimizely logs

const Optimizely: FC<OptimizelyProps> = ({ children, sdkKey, userId }) => {
  const optimizelyInstance = createInstance({
    sdkKey,
  });
  if (!userId) {
    return children;
  }

  return (
    <OptimizelyProvider
      optimizely={optimizelyInstance}
      user={{
        id: userId,
      }}
    >
      <OptimizelyAnalyticsEvent />
      {children}
    </OptimizelyProvider>
  );
};

const MemoizedOptimizely = memo(Optimizely, (prevProps, nextProps) => {
  return (
    prevProps.sdkKey === nextProps.sdkKey &&
    prevProps.userId === nextProps.userId
  );
});

export { Optimizely, MemoizedOptimizely };
